import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ role, children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-terracotta" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (user.force_password_change && location.pathname !== "/set-password") {
    return <Navigate to="/set-password" replace />;
  }
  if (!user.force_password_change && location.pathname === "/set-password") {
    return <Navigate to={user.role === "admin" ? "/admin" : "/dealer"} replace />;
  }
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/dealer"} replace />;
  }
  return children;
}
